import React from "react";
import { Table, TableBody } from "@material-ui/core";
import IContact from "../../models/IContact";
import TableHeader, { IHeaderCell } from "../tables/TableHeader";
import { sortRows, updateSorts, getCurrentOrderBy } from "../tables/helperFuncs";
import ContactRow from "./ContactRow";

export interface IContactListProps {
  contacts: Array<IContact>;
  onRequestRefresh: Function;
  type: string;
}

const ContactList = (props: IContactListProps) => {
  const {
    contacts: { length },
    onRequestRefresh,
    type,
  } = props;

  const [cells, setCells] = React.useState<Array<IHeaderCell<IContact>>>([
    { propName: "ID", label: "ID", numeric: true },
    { propName: "LastName", label: "Last", numeric: false, order: "asc" },
    { propName: "FirstName", label: "First", numeric: false },
    { propName: "EmailAddress", label: "Email", numeric: false },
    { propName: "ID", label: " ", numeric: false },
  ]);

  const handleRequestSort = (cell: IHeaderCell<IContact>) => {
    setCells(updateSorts<IContact>(cells, cell));
  };

  return (
    <Table aria-labelledby="tableTitle" size="medium" aria-label="contact-list">
      <TableHeader cells={cells} rowCount={length} onRequestSort={handleRequestSort} />
      <TableBody>
        {sortRows(props.contacts, getCurrentOrderBy(cells)).map(contact => (
          <>
            <ContactRow {...contact} onRequestRefresh={onRequestRefresh} type={type} />
          </>
        ))}
      </TableBody>
    </Table>
  );
};

export default ContactList;
